<footer>
  <div>
    <div class="footerContent">
      <span>© {{copyrightYear}} {{brandName}}</span>     
      <ul>       
        <li *ngFor="let item of linkList">
          <a [href]="item.link">
            {{item.text}}
          </a>
        </li>        
      </ul>      
    </div>
  </div>
</footer>
